import { Link } from "react-router-dom";
import { CalendarCheck, MapPin } from "lucide-react";
import StudioGallery from "@/components/StudioGallery";
import { FadeUp, MaskedLine } from "@/components/Reveal";
import { CONTACTS, IMAGES } from "@/data/site";

const FULL_GALLERY = [
    { src: IMAGES.attesa2, caption: "La sala d'attesa", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.accettazione, caption: "L'accettazione", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.attesa1, caption: "La sala d'attesa", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.attesa3, caption: "La sala d'attesa", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.studio1b, caption: "Lo studio 1", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.hero, caption: "Lo studio 1", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.studio2, caption: "Lo studio 2", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.studio2b, caption: "Lo studio 2", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.studio2c, caption: "Lo studio 2", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: IMAGES.tac2, caption: "La TAC 3D in sede", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
];

export default function Studio() {
    return (
        <>
            <section
                data-testid="studio-hero"
                className="bg-white pt-32 pb-16 sm:pt-40 md:pb-20"
            >
                <div className="mx-auto max-w-7xl px-4 sm:px-8 md:px-12">
                    <FadeUp y={14}>
                        <p className="flex items-center gap-3 text-xs font-medium uppercase tracking-[0.3em] text-petrol">
                            <span className="h-px w-10 bg-petrol" />
                            Lo Studio
                        </p>
                    </FadeUp>
                    <h1 className="mt-7 max-w-3xl font-serif text-4xl font-normal leading-[1.08] tracking-tight text-ink sm:text-5xl md:text-6xl">
                        <MaskedLine delay={0.15}>Vieni a vedere</MaskedLine>
                        <MaskedLine delay={0.3}>
                            <span className="italic text-petrol">dove lavoriamo.</span>
                        </MaskedLine>
                    </h1>
                    <FadeUp delay={0.5}>
                        <p className="mt-6 max-w-2xl text-base font-light leading-relaxed tracking-wide text-body sm:text-lg">
                            Sale luminose, strumentazione aggiornata e la TAC 3D
                            direttamente in sede: fatti un giro dello studio prima
                            ancora di venire a trovarci.
                        </p>
                    </FadeUp>
                </div>
            </section>

            <StudioGallery items={FULL_GALLERY} showHeading={false} stagger={false} />

            <section
                data-testid="studio-cta"
                className="bg-white py-20 text-center sm:py-24"
            >
                <div className="mx-auto max-w-2xl px-4">
                    <h2 className="font-serif text-3xl font-normal leading-tight text-ink sm:text-4xl">
                        <MaskedLine>Dal vivo è ancora meglio.</MaskedLine>
                    </h2>
                    <FadeUp delay={0.2}>
                        <p className="mt-4 text-base font-light leading-relaxed text-body">
                            Ci trovi in {CONTACTS.address}.
                        </p>
                        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
                            <Link
                                to="/contatti"
                                data-testid="studio-cta-prenota"
                                className="inline-flex items-center gap-3 rounded-full bg-petrol px-8 py-4 text-sm font-normal text-white shadow-sm transition-all duration-300 hover:bg-petrol-dark hover:shadow-md active:scale-[0.98]"
                            >
                                <CalendarCheck className="h-4 w-4" />
                                Prenota una visita
                            </Link>
                            <a
                                href={CONTACTS.mapsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="studio-cta-maps"
                                className="inline-flex items-center gap-2 rounded-full border border-petrol px-6 py-3.5 text-sm font-normal text-petrol transition-all duration-300 hover:bg-petrol hover:text-white active:scale-[0.98]"
                            >
                                <MapPin className="h-4 w-4" />
                                Come raggiungerci
                            </a>
                        </div>
                    </FadeUp>
                </div>
            </section>
        </>
    );
}
